export default __webpack_public_path__ + "static/media/olivia.2dcd9e1f.jpg";